export enum TYPES {
  SET_NOME_USUARIO = '@@navbar/SET_NOME_USUARIO',
  SET_MODAL_TROCAR_SENHA = '@@navbar/SET_MODAL_TROCAR_SENHA'
}

export interface NAVBAR {
  nomeUsuario: string
}
